/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class AlarmCodeService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'AlarmCodeService\' loaded');
    }
}

export { AlarmCodeService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmCodeService.js